import {
  computed,
  ref,
} from '@nuxtjs/composition-api';
import { defineStore } from 'pinia';

import { useSentry } from '@/plugins/sentry';

import { checkStatusRequest } from '../api';

import { CLOSED_SALES_STATUSES } from './constants';

import type { ClosedSalesStatuses } from './types';

export const useClosedSalesStore = defineStore('closedSalesStore', () => {
  const statusClosedSales = ref<ClosedSalesStatuses>('none');

  const hasRequestStatus = computed(() => {
    return statusClosedSales.value === CLOSED_SALES_STATUSES.active;
  });

  async function handlerCheckStatus () {
    try {
      statusClosedSales.value = await checkStatusRequest();
    } catch (error) {
      useSentry().captureException(error);
    }
  }

  return {
    statusClosedSales,
    hasRequestStatus,
    handlerCheckStatus,
  };
});
